import CreditCardNumber from './credit-card-number';

export default CreditCardNumber;
